import { type ReactNode } from "react"
import scrollToPersonalForm from "../../scrollToPersonalForm"
import { DLClickEventExtended } from "../DLEvents"
import getTextFromNode from "../../getTextFromNode"

const handleClickBanner = (buttonText: string, bannerTitleH1: ReactNode, withoutScroll = false) => {
  DLClickEventExtended({
    name: buttonText,
    eventAction: getTextFromNode(bannerTitleH1),
    placement: "banner",
  })

  if (withoutScroll) return
  scrollToPersonalForm()
}

const handleClickStickyBtn = () => {
  DLClickEventExtended({
    name: "sticky",
    eventCategory: "click_cta",
    eventAction: "Стики-кнопка",
    placement: "banner",
  })
  scrollToPersonalForm()
}

export { handleClickBanner, handleClickStickyBtn }
